import SVG, { Props as SVGProps } from 'react-inlinesvg'
import { useEffect, useState } from 'react'

export interface SvgIconProps extends Omit<SVGProps, 'src' | 'preProcessor'> {
  iconName: string
  size?: number
  width?: number
  height?: number
  color?: string
}

const DEFAULT_SIZE: number = 32

const SvgIcon = ({ iconName, size, width, height, color, ...props }: SvgIconProps) => {
  const iconSize: number = size ? size : DEFAULT_SIZE
  const [iconSrc, setIconSrc] = useState<string>('')

  useEffect(() => {
    const loadIcon = async () => {
      try {
        const cleanIconName = iconName.replaceAll('.svg', '') || 'default'
        // Use dynamic import to load the icon
        const iconModule = await import(`../../assets/icons/${cleanIconName}.svg`)
        setIconSrc(iconModule.default)
      } catch (error) {
        console.warn(`Icon not found: ${iconName}, falling back to default`)
        try {
          const defaultIcon = await import(`../../assets/icons/default.svg`)
          setIconSrc(defaultIcon.default)
        } catch (defaultError) {
          console.error('Default icon not found')
        }
      }
    }

    loadIcon()
  }, [iconName])

  if (!iconSrc) {
    return null
  }

  return (
    // @ts-ignore
    <SVG
      src={iconSrc}
      width={width ?? iconSize}
      height={height ?? iconSize}
      preProcessor={code => {
        if (color) {
          // Replace all fill attributes with the specified color
          return code.replace(/fill="[^"]*"/g, `fill="${color}"`).replace(/fill='[^']*'/g, `fill="${color}"`)
        }
        return code
      }}
      {...props}
    />
  )
}

export default SvgIcon
